import facebook from "./img/icons/fb.svg";
import vc from "./img/icons/vc.svg";
import insta from "./img/icons/insta.svg";
import medium from "./img/icons/medium.svg";

export const socials = [
  {
    name: "medium",
    link: "https://medium.com/everpoint",
    img: medium,
  },
  {
    name: "vc",
    link: "https://vc.ru/u/210116-kompaniya-everpoint?to=47632",
    img: vc,
  },
];
